import React, { useMemo } from 'react';

function truncateLabel(text, maxLen = 22) {
  const s = String(text || '').trim();
  if (s.length <= maxLen) return s;
  return `${s.slice(0, maxLen - 1)}…`;
}

export default function DashboardEventsByNameBars({ labels, values }) {
  const { maxCount, rows } = useMemo(() => {
    const safeLabels = Array.isArray(labels) ? labels : [];
    const safeValues = Array.isArray(values) ? values : [];
    const max = Math.max(1, ...safeValues.map((v) => Number(v) || 0));

    const builtRows = safeLabels.map((label, i) => ({
      label,
      value: Number(safeValues[i]) || 0,
    }));

    return { maxCount: max, rows: builtRows };
  }, [labels, values]);

  if (!rows.length) return null;

  return (
    <div
      className="member-dashboard__events-bars"
      role="group"
      aria-label="Events by name chart"
    >
      <ul className="member-dashboard__events-bars-list">
        {rows.map((row, i) => (
          <li
            key={`${row.label}-${i}`}
            className="member-dashboard__events-bar-row"
          >
            <span
              className="member-dashboard__events-bar-label"
              title={row.label}
            >
              {truncateLabel(row.label)}
            </span>
            <meter
              className="member-dashboard__events-bar-meter"
              min={0}
              max={maxCount}
              value={row.value}
              aria-label={`${row.label}: ${row.value}`}
            />
            <span className="member-dashboard__events-bar-count">
              {row.value}
            </span>
          </li>
        ))}
      </ul>
      <p className="member-dashboard__events-bars-axis">Count</p>
    </div>
  );
}
